import Model from "./model";

const IMAGE_FILE_SERVER_URL = process.env.VUE_APP_IMAGE_FILE_SERVER_URL || "";
const MONITORING_STATUS_CD = {
  ON: "1",
  OFF: "0",
};

/* eslint-disable no-unused-expressions */
class MonitoringTarget extends Model {
  constructor(projectId, monitoringTargetId = null) {
    super();

    this._projectId = projectId;
    this._monitoringTargetId = monitoringTargetId;

    this._organizationId;
    this._name = "";
    this._note = "";
    this._imagePath;
    this._resizeImagePath;
    this._monitoringStatusCd;
    this._deletedFlag;
    this._version;
    this._resourceId;
    this._createdAt;
    this._createdBy;
    this._updatedAt;
    this._updatedBy;
    this._deletedAt;
    this._deletedBy;
  }

  get projectId() {
    return this._projectId;
  }

  set projectId(value) {
    this._projectId = value;
  }

  get monitoringTargetId() {
    return this._monitoringTargetId;
  }

  set monitoringTargetId(value) {
    this._monitoringTargetId = value;
  }

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get name() {
    return this._name;
  }

  set name(value) {
    this._name = value;
  }

  get note() {
    return this._note;
  }

  set note(value) {
    this._note = value;
  }

  get imagePath() {
    return this._imagePath;
  }

  set imagePath(value) {
    this._imagePath = value;
  }

  get resizeImagePath() {
    return this._resizeImagePath;
  }

  set resizeImagePath(value) {
    this._resizeImagePath = value;
  }

  get monitoringStatusCd() {
    return this._monitoringStatusCd;
  }

  set monitoringStatusCd(value) {
    this._monitoringStatusCd = value;
  }

  get deletedFlag() {
    return this._deletedFlag;
  }

  set deletedFlag(value) {
    this._deletedFlag = value;
  }

  get version() {
    return this._version;
  }

  set version(value) {
    this._version = value;
  }

  get resourceId() {
    return this._resourceId;
  }

  set resourceId(value) {
    this._resourceId = value;
  }

  get createdAt() {
    return this._createdAt;
  }

  set createdAt(value) {
    this._createdAt = value;
  }

  get createdBy() {
    return this._createdBy;
  }

  set createdBy(value) {
    this._createdBy = value;
  }

  get updatedAt() {
    return this._updatedAt;
  }

  set updatedAt(value) {
    this._updatedAt = value;
  }

  get updatedBy() {
    return this._updatedBy;
  }

  set updatedBy(value) {
    this._updatedBy = value;
  }

  get deletedAt() {
    return this._deletedAt;
  }

  set deletedAt(value) {
    this._deletedAt = value;
  }

  get deletedBy() {
    return this._deletedBy;
  }

  set deletedBy(value) {
    this._deletedBy = value;
  }

  isRegisterd() {
    return !!this.monitoringTargetId;
  }

  json() {
    return {
      projectId: this._projectId,
      monitoringTargetId: this._monitoringTargetId,
      organizationId: this._organizationId,
      name: this._name,
      note: this._note,
      imagePath: this._imagePath,
      resizeImagePath: this._resizeImagePath,
      monitoringStatusCd: this._monitoringStatusCd,
      deletedFlag: this._deletedFlag,
      version: this._version,
      resourceId: this._resourceId,
      createdAt: this._createdAt,
      createdBy: this._createdBy,
      updatedAt: this._updatedAt,
      updatedBy: this._updatedBy,
      deletedAt: this._deletedAt,
      deletedBy: this._deletedBy,
    };
  }

  copy() {
    const monitoringTarget = new MonitoringTarget(this.projectId, this.monitoringTargetId);

    monitoringTarget.projectId = this.projectId;
    monitoringTarget.monitoringTargetId = this.monitoringTargetId;
    monitoringTarget.organizationId = this.organizationId;
    monitoringTarget.name = this.name;
    monitoringTarget.note = this.note;
    monitoringTarget.imagePath = this.imagePath;
    monitoringTarget.resizeImagePath = this.resizeImagePath;
    monitoringTarget.monitoringStatusCd = this.monitoringStatusCd;
    monitoringTarget.deletedFlag = this.deletedFlag;
    monitoringTarget.version = this.version;
    monitoringTarget.resourceId = this.resourceId;
    monitoringTarget.createdAt = this.createdAt;
    monitoringTarget.createdBy = this.createdBy;
    monitoringTarget.updatedAt = this.updatedAt;
    monitoringTarget.updatedBy = this.updatedBy;
    monitoringTarget.deletedAt = this.deletedAt;
    monitoringTarget.deletedBy = this.deletedBy;

    return monitoringTarget;
  }

  // 追加項目
  getImageFileUrl() {
    let res = "";
    if (this.imagePath) {
      res = `${IMAGE_FILE_SERVER_URL}/${this.imagePath}`;
    }
    return res;
  }
}
/* eslint-enable */

class UploadImageFileFormItem {
  constructor() {
    this._imagePath = null;
    this._imageFileUrl = null;
    this._uploadImageFile = null;
  }

  get imagePath() {
    return this._imagePath;
  }

  set imagePath(value) {
    this._imagePath = value;
  }

  get imageFileUrl() {
    return this._imageFileUrl;
  }

  set imageFileUrl(value) {
    this._imageFileUrl = value;
  }

  get uploadImageFile() {
    return this._uploadImageFile;
  }

  set uploadImageFile(value) {
    this._uploadImageFile = value;
  }

  /* 算出プロパティ */
  isImageFileUpload() {
    // 画像ファイルが設定されている
    return !!this.uploadImageFile;
  }

  isImageFileDelete() {
    // 画像登録されていたが、現在画面に反映されていない
    return !this.imageFileUrl && !!this.imagePath;
  }

  isSelected() {
    // 画像のURL設定されている
    return !!this.imageFileUrl;
  }

  /* インスタンス生成 */
  static createInstance(monitoringTarget) {
    const uploadImageFileFormItem = new UploadImageFileFormItem();
    uploadImageFileFormItem.imageFileUrl = monitoringTarget.getImageFileUrl();
    uploadImageFileFormItem.imagePath = monitoringTarget.imagePath;

    return uploadImageFileFormItem;
  }

  /* フォーム操作によるプロパティの変更 */
  selectImageFile(imageFile) {
    this.uploadImageFile = imageFile;
    this.imageFileUrl = URL.createObjectURL(imageFile);
  }

  clearImageFile() {
    this.imageFileUrl = null;
    this.uploadImageFile = null;
  }
}

export {
  MonitoringTarget,
  UploadImageFileFormItem,
  MONITORING_STATUS_CD,
};
